// Sidebar entries owned by the Drive module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { resources, scopes } from '@vnetwork/datacentral-core/auth'
import { drivePaths } from './paths'

// The sidebar fields Drive's entry uses. Structurally the app's SidebarType
// (src/types/shared): src/app/nav.tsx places these entries, so a drift between
// the two fails typecheck there.
interface DriveNavItem {
    title: string
    path: string
    rsname?: string
    require_scopes?: string[]
    visible_permission_denied?: boolean
}

export const driveNav = {
    list: {
        title: 'drive-title',
        path: drivePaths.drive,
        rsname: resources.drives,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
} satisfies Record<string, DriveNavItem>
